import { useState } from 'react';
import { useStore } from 'react-redux';
import { ViiisionSuccessSnackbar } from '../../../ViiisionSuccessSnackbar';
import { ViiisionMenu } from './ViiisionMenu';
import { ViiisionMenuItem } from './ViiisionMenuItem';
import { downloadImage } from '../../../../util/downloadQrcode';
import { useAppSelector } from '../../../../store/hooks';
import { _topics } from '../../../../store/slices/topicSlice';

export type QRMenuProps = {
	topicId: string;
};

export const QRMenu = (props: QRMenuProps) => {
	const { topicId } = { ...props };
	const store = useStore();
	const [copySuccess, setCopySuccess] = useState(false);
	const [anchor, setAnchor] = useState(null);
	const topics = useAppSelector(_topics);
	const selectedTopic = topics[topicId];

	const copyToClipboard = () => {
		// Get the latest state from Redux store at copy time
		const state = store.getState();
		const currentTopic = state.topic.topics[topicId];

		// Try to get organization directly from topic, or via location
		let organization;
		if (currentTopic?.organizationId) {
			organization = state.organization.organizations[currentTopic.organizationId];
		} else if (currentTopic?.locationId) {
			const location = state.location.locations[currentTopic.locationId];
			if (location?.organizationId) {
				organization = state.organization.organizations[location.organizationId];
			}
		}

		const { appSlug } = organization || {};
		const { pageSlug } = currentTopic?.metadata || {};

		const url =
			appSlug && pageSlug
				? `${process.env.REACT_APP_LIIINGO_WEBAPP_URL}/${appSlug}/${pageSlug}`
				: `${process.env.REACT_APP_LIIINGO_WEBAPP_URL}/topic/${topicId}`;

		navigator.clipboard.writeText(url);
		setCopySuccess(true);
	};

	return (
		<>
			<ViiisionMenu anchor={anchor} setAnchor={setAnchor} name="QRMenu">
				<ViiisionMenuItem text="Copy Link" handleClick={copyToClipboard} setAnchor={setAnchor} />
				<ViiisionMenuItem
					text="Download PNG"
					handleClick={() => downloadImage(topicId, selectedTopic.name[0].name, 'png')}
					setAnchor={setAnchor}
				/>
				<ViiisionMenuItem
					text="Download SVG"
					handleClick={() => downloadImage(topicId, selectedTopic.name[0].name, 'svg')}
					setAnchor={setAnchor}
				/>
			</ViiisionMenu>
			<ViiisionSuccessSnackbar
				open={copySuccess}
				text="Link copied successfully"
				onClose={() => setCopySuccess(false)}
			/>
		</>
	);
};
